import { supabase } from "@/integrations/supabase/client";

export type ConsumeResponse = {
  scenario_id: string;
  prefill: {
    external_household_ref: string;
    external_policy_ref: string;
    external_advisor_ref?: string;
    external_client_ref?: string;
    available_loan_amount: number;
    current_loan_balance: number;
    carrier_loan_rate: number;
    requested_amount: number;
    requested_purpose: string;
  };
};

export async function consumeLaunchToken(token: string): Promise<ConsumeResponse> {
  const { data, error } = await supabase.functions.invoke("integration-v1-consume", { body: { token } });
  if (error) throw error;
  if (!data || typeof data !== "object" || !("scenario_id" in data)) {
    throw new Error("unexpected response from integration-v1-consume");
  }
  return data as ConsumeResponse;
}